import { Recepcion } from './../../../models/recepcion.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-recepcion",
    templateUrl: "./recepcion.component.html",
    providers: [FormService]
})

export class RecepcionComponent {
    public rows = [];
    public actualRow;
    public recepcion: Recepcion;
    public form;

    matcher : FormService;

    constructor(){

        this.form = new FormGroup({
            superedif: new FormControl('', Validators.compose([
                Validators.required
            ])),
            destino_cont: new FormControl('', Validators.compose([
                Validators.required
            ]))
        })


        if(!JSON.parse(localStorage.getItem("recepcion"))){
            localStorage.setItem("recepcion", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("recepcion"));

            this.form.controls['superedif'].setValue(this.rows[0]?this.rows[0].superedif:'');
            this.form.controls['destino_cont'].setValue(this.rows[0]?this.rows[0].destino_cont:'');
        }
        
    }


    add_recepcion(){

        localStorage.setItem("recepcion",JSON.stringify([]));
        this.actualRow = localStorage.getItem("recepcion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            superedif: this.form.value.superedif,
            destino_cont : this.form.value.destino_cont
          
        })
        localStorage.setItem("recepcion", JSON.stringify(this.rows));
    }
  
    delete_recepcion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("recepcion", JSON.stringify(this.rows));
            }
        }
    }  

}